import { useState } from 'react'
import { message as $message } from 'antd'

import { queryCardApi, updateCardApi, queryShopNumWithSorted } from '@/services/supplier/supplierUser'

interface useCardReturn {
    /** 用户卡片信息对象 */
    cardInfo: object
    /** 查询时的loading状态 */
    loading: boolean
    /** 查询用户卡片信息 */
    queryCardInfo: () => void
    /** 更新用户的卡片信息 */
    updateCardInfo: (params: any) => Promise<{ success: string; message: string }>
}

/**
 * 商家卡片信息，主要是商家的一些扩展信息
 * @returns @interface useCardReturn
 */
export default function useCardInfo(): useCardReturn {
    const [cardInfo, setCardInfo] = useState({})
    const [loading, setLoading] = useState(false)

    const queryCardInfo = async () => {
        setLoading(true)
        try {
            const results = await Promise.all([queryCardApi(), queryShopNumWithSorted()])
            if (results.every(v => v.success)) {
                const [cardJson, shopJson] = results
                setCardInfo({
                    ...(cardJson?.data || {}),
                    mainPlatformList: shopJson?.data,
                })
            } else {
                const error = results.find(v => !v.success)
                if (error) $message.error(error.message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
        setLoading(false)
    }

    const updateCardInfo = (params: any) => {
        return updateCardApi(params).then(res => {
            const { success, message } = res
            if (!success) {
                $message.error(message)
            } else {
                setCardInfo(params)
            }
            return res
        })
    }

    return { cardInfo, loading, queryCardInfo, updateCardInfo }
}
